// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Gav1V","description":"styles_description__1nJ6g"};